import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const K = styled.span`
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const V = styled.span`
  font-size: 13.5px;
  font-weight: 700;
  color: ${(p) => p.theme.tokens.colors.ink};
`;
